import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class UserEditValidator {

    second_name = [
        Validators.required,
        Validators.maxLength(255)
    ];

    first_name = [
        Validators.required,
        Validators.maxLength(255)
    ];

    last_name = [
        Validators.maxLength(255)
    ];

    date_of_birth = [
        Validators.maxLength(255)
    ];

    login = [
        //Validators.required,
        Validators.minLength(5),
        Validators.maxLength(255),
        Validators.email
    ];

    password = [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(255),
        // Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([0-9A-Za-z])+$')
    ];

    email = [
        Validators.minLength(5),
        Validators.maxLength(255),
        Validators.email
    ];

    phone = [
        Validators.maxLength(255)
    ];

    // Error messages
    errorMessages = {
        second_name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
        first_name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
        last_name: [
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
        date_of_birth: [
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
        login: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '5' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'email', 
                message: 'MESSAGES.EMAIL_FORMAT',
                options: null
            }
        ],
        old_password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            }
        ],
        password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            }
        ],
        confirm_password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '8' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.PASSWORD_PATTERN',
                options: null
            },
            {
                type: 'mustMatch', 
                message: 'MESSAGES.PASWORD_CONFIRMATION',
                options: null
            }
        ],
        email: [
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '5' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            },
            {
                type: 'email', 
                message: 'MESSAGES.EMAIL_FORMAT',
                options: null
            }
        ],
        phone: [
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '255' }
            }
        ],
    }
}